import { render } from "./Index.vue?vue&type=template&id=d2f1bb44&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=d2f1bb44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f1bb44"],['__file',"components/Customers/Matches/Edit/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2f1bb44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2f1bb44', __exports__)) {
    api.reload('d2f1bb44', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=d2f1bb44&scoped=true", () => {
    api.rerender('d2f1bb44', render)
  })

}


export default __exports__